import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CadastrarVendasService {

  constructor(private http: HttpService) { }

  automaticReuse(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/automaticReuse/industria/listaEmpresasIndustria', data, successHandle, errorHandle);
  }
  geraReusoVenda(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doPost('/automaticReuse/industria/geraReusoVenda', data, successHandle, errorHandle);
  }
  retornaFornecedor(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doGet('/automaticReuse/industria/retornaFornecedoresReusoVenda/', data, successHandle, errorHandle);
  }
  alteraDados(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doPut('/automaticReuse/industria/alteraDadosFornecedor', data, successHandle, errorHandle);
  }
 
}
